import styled, { css } from 'styled-components'

export const SC_Icon = styled.div.attrs(props => ({
  	className: 'icon-container'
}))`
	position: relative;

	.icon-ratio {
		margin-top: ${props => props.margin ? (props.theme[props.margin[0]] ? props.theme[props.margin[0]] : props.margin[0]) : 0};
		margin-bottom: ${props => props.margin ? (props.theme[props.margin[1]] ? props.theme[props.margin[1]] : props.margin[1]) : 0};
	}

	canvas {
		height: ${props => props.height ? props.height : '25px'};
	}

	svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		// height: ${props => props.height ? props.height : '25px'};
		// width: ${props => props.height ? props.height : '25px'};
		transition: all .3s ease;

		${props => props.rotate ? `
		transform: rotate(${props.rotate});
		` : null }
		
		path, polygon, polyline, g[fill], rect, circle {

			fill: ${props => props.theme.white};

			${props => props.fill ? 
			`fill: ${props.theme[props.fill] ? props.theme[props.fill] : props.fill}!important;` 
			: null }

			${props => props.altFill ?`
			&[style*="fill: rgb(102, 102, 102);"]{
				fill: ${props.theme[props.altFill] ? props.theme[props.altFill] : props.altFill}!important;
			` : null }

			${props => props.fillYiq ? 
			`fill: ${props.theme.themeColorsYiq[props.fillYiq] ? props.theme.themeColorsYiq[props.fillYiq] : props.fillYiq}!important;` 
			: null }

		}
	}
`

export const SC_IconRatio = styled.div.attrs(props => ({
	className: 'icon-ratio'
}))`
	display: block;
	position: relative;
`

export const SC_CanvasRatio = styled.canvas.attrs(props => ({
	
}))`
	display: block;
	visibility: hidden;
`